module.exports = __webpack_public_path__ + "static/media/room5yellow.ba25bbc0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/bridging-the-gap/room5yellow.png
// module id = 362
// module chunks = 0